export default function Hero() {
  return (
    <section className="relative flex min-h-[640px] w-full items-center justify-center overflow-hidden md:min-h-[700px]">
      <img
        src="https://readdy.ai/api/search-image?query=stylized%20abstract%20art%20of%20a%20vibrant%20manga%20cityscape%20at%20dusk%20with%20floating%20comic%20panels%20and%20sparkles%2C%20warm%20orange%20and%20deep%20amber%20tones%2C%20dynamic%20modern%20illustration%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="漫迹漫画追更官网 背景图"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-background-50" />

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-24 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
          <i className="ri-notification-4-line" />
          超过 1000 万次追更提醒已送达
        </span>
        <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          追更不迷路，<br className="hidden md:block" />
          精彩不错过
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          漫迹是专业的漫画追更工具，提供漫画更新提醒、最新话推送与连载进度查询。
          搭配漫画更新日历与追更社区，让你第一时间掌握每一部作品的最新动态。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#tracking"
            className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始追更提醒
          </a>
          <a
            href="#calendar"
            className="whitespace-nowrap rounded-full border border-background-50/40 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
          >
            查看更新日历
          </a>
        </div>
        <div className="mt-12 grid w-full max-w-2xl grid-cols-3 gap-4">
          {[
            { num: '3000+', label: '连载作品' },
            { num: '120万+', label: '追更读者' },
            { num: '99.9%', label: '更新提醒及时率' },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-lg bg-background-50/10 px-4 py-5 backdrop-blur"
            >
              <p className="font-heading text-2xl text-background-50 md:text-3xl">{s.num}</p>
              <p className="mt-1 text-xs text-background-200">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}